<div class="card bg-light" style="margin-top: 10px;">
    <div class="card-body" style="background-color:snow">
        <p-table [value]="myMinutes" [scrollable]="true" scrollHeight="176px">
            <ng-template pTemplate="header">
                <tr>
                    <th *ngFor="let col of cols">
                        {{col.header}}
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-minute>
                <tr style="font-size: small">
                    <td>{{minute.hearingDate | date: 'M/d/yyyy'}}</td>
                    <td>{{minute.minutesNote}}</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
